export type ReactiveRepeatableMagramaSlot = 1 | 2 | 3;

/** Resolves row indexes into the legacy three-slot MAGRAMA contract. */
export class ReactiveRepeatableMagramaSlotMapper {
    public static resolveThreeSlot(rowIndex: number): ReactiveRepeatableMagramaSlot {
        const normalizedRowIndex = this.normalizeRowIndex(rowIndex);

        return Math.min(normalizedRowIndex + 1, 3) as ReactiveRepeatableMagramaSlot;
    }

    public static normalizeRowIndex(rowIndex: number): number {
        return Number.isInteger(rowIndex) && rowIndex >= 0 ? rowIndex : 0;
    }
}
